// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { media } from '@toggl/style'

type Props = {
  children?: React.Node,
  className?: string,
}

export const ContainerReadMore = ({ className, children }: Props) => (
  <Root className={className}>{children}</Root>
)

const Root: React.ComponentType<any> = styled.div`
  ${media.mq[1]} {
    display: flex;
    gap: 30px;
  }
`
